export const GIG_PACKAGE_TYPE = {
    BASIC: 'GIG_PACKAGE_TYPE_BASIC',
    STANDARD: 'GIG_PACKAGE_TYPE_STANDARD',
    PREMIUM: 'GIG_PACKAGE_TYPE_PREMIUM',
};
